<template>
  <v-app class="bgImage">
    <m-errorbox ref="errorBox"></m-errorbox>

    <!-- Add a toolbar above the navbar to identify HUNTSMAN TEST SITE -->

    <navbar v-if="$route.name == 'log' || isMultiDevice">
      <v-toolbar-title
        v-if="!loaded"
        class="text-uppercase secondary--text text--darken-3"
      >
        <span class="font-weight-light">Please </span>
        <span class="font-weight-medium">Wait...</span>
      </v-toolbar-title>

      <v-toolbar-title
        v-else-if="isMultiDevice"
        class="text-uppercase secondary--text text--darken-3"
      >
        <span class="font-weight-light">Device </span>
        <span class="font-weight-medium">
          Comparison
        </span>
      </v-toolbar-title>

      <v-toolbar-title
        v-else
        class="text-uppercase secondary--text text--darken-3"
      >
        <span class="font-weight-light">{{
          $store.state.device
            ? $store.state.device.device_name ||
              $store.state.device.device_token
            : "Loading..."
        }}</span>
        <span
          class="font-weight-medium"
          v-if="
            $store.state.device &&
              ($store.state.device.address || $store.state.device.city)
          "
        >
          | {{ $store.state.device.address }}, {{ $store.state.device.city }},
          {{ $store.state.device.state }}, {{ $store.state.device.postcode }}
        </span>
      </v-toolbar-title>
      <!--m-menu icon="mdi-content-save" label="File">
						<m-item icon="mdi-open-in-app" @click="onMenuFileOpen">Load Local File</m-item>
						<m-item icon="mdi-content-save">Download to Local File</m-item>
						<m-item icon="mdi-close">Close</m-item>
			</m-menu-->
      <!--m-menu v-if="loaded" icon="mdi-clock-outline" label="View Period">
						<m-item icon="mdi-timer" @click="()=>setPeriod(4)">4 Hours</m-item>
						<m-item icon="mdi-camera-timer" @click="()=>setPeriod(6)">6 Hours</m-item>
						<m-item icon="mdi-av-timer" @click="()=>setPeriod(8)">8 Hours</m-item>
						<m-item icon="mdi-clock-outline" @click="()=>setPeriod(12)">12 Hours</m-item>
						<m-item icon="mdi-calendar-clock" @click="()=>setPeriod(24)">1 Day</m-item>
						<m-item icon="mdi-timetable" @click="()=>setPeriod(24*7)">1 Week</m-item>
			</m-menu-->
      <v-spacer></v-spacer>

      <m-menubutton
        icon="mdi-information"
        @click="$router.push('/deviceinfo/' + $route.params.id)"
        >Info</m-menubutton
      >
      <m-menu v-if="loaded" icon="mdi-table-settings" label="Table View">
        <m-item icon="mdi-table-column-remove" @click="onMenuTableHide"
          >Hide Table</m-item
        >
        <m-item icon="mdi-table-large" @click="onMenuTableAll"
          >All Readings</m-item
        >
        <m-item icon="mdi-chart-timeline-variant" @click="onMenuTableMaxMin"
          >Daily Max/Min</m-item
        >
      </m-menu>
      <v-menu offset-y v-if="loaded" style="z-index:10;">
        <template v-slot:activator="{ on }">
          <v-btn
            text
            class="secondary--text text--darken-3 ml-3"
            v-on="on"
            dense
          >
            <v-icon left>mdi-calendar</v-icon>
            Pick Date
          </v-btn>
        </template>
        <v-list dense class="pt-0 pb-0">
          <v-date-picker
            :value="dateString"
            @input="onDateSelect"
            :min="
              $store.state.device &&
                new Date(
                  $store.state.device.first_reading * 1000 + 24 * 60 * 60
                )
                  .toISOString()
                  .split('T')[0]
            "
            :max="
              $store.state.device &&
                new Date($store.state.device.last_reading * 1000 - 24 * 60 * 60)
                  .toISOString()
                  .split('T')[0]
            "
          ></v-date-picker>
        </v-list>
      </v-menu>

      <v-spacer></v-spacer>
    </navbar>

    <!-- NAVBAR FOR LINK USERS (NOT LOGGED IN) -->
    <v-app-bar v-else app color="primary">
      <v-toolbar-title class="text-uppercase secondary--text text--darken-3">
        <span class="font-weight-light">Huntsman </span>
        <span class="font-weight-medium">Cloud </span>
        <span class="font-weight-light">Shared </span>
        <span class="font-weight-medium">Link</span>

        <span class="font-weight-light">{{
          $store.state.device
            ? $store.state.device.device_name ||
              $store.state.device.device_token
            : "Loading..."
        }}</span>
        <!--span
					class="font-weight-medium"
					v-if="$store.state.device && ($store.state.device.address || $store.state.device.city)"
				> | {{$store.state.device.address}}, {{$store.state.device.city}}, {{$store.state.device.state}}, {{$store.state.device.postcode}} </span-->
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <m-menu v-if="loaded" icon="mdi-table-settings" label="Table View">
        <m-item icon="mdi-table-column-remove" @click="onMenuTableHide"
          >Hide Table</m-item
        >
        <m-item icon="mdi-table-large" @click="onMenuTableAll"
          >All Readings</m-item
        >
        <m-item icon="mdi-chart-timeline-variant" @click="onMenuTableMaxMin"
          >Daily Max/Min</m-item
        >
      </m-menu>
      <v-spacer></v-spacer>
    </v-app-bar>

    <v-content v-if="linkExpired" class="error--text text-center mt-10">
      <h2>
        The link address you are using has expired. You will need a fresh link
        to view this chart.
      </h2>
    </v-content>
    <v-content v-if="linkInvalid" class="error--text text-center mt-10">
      <h2>The link address you have entered is invalid.</h2>
    </v-content>
    <v-content v-else class="secondary--text text--darken-2">
      <input
        type="file"
        ref="fileOpenElem"
        accept=".cht, .log, .jlg"
        style="display:none;"
        @change="openFile"
      />

      <v-container
        v-show="!(loaded || linkExpired || linkInvalid)"
        fluid
        fill-height
      >
        <v-row justify="center" align="center">
          <v-col justify="center" align="center">
            <v-progress-circular
              :value="apiRequestProgress.toFixed()"
              :indeterminate="apiRequestProgress == 100"
              size="250"
            ></v-progress-circular>
            <h1 v-if="apiRequestProgress == 100" class="mt-4">Loading...</h1>
            <h1 v-else class="mt-4">
              Downloading {{ apiRequestProgress.toFixed() }}% ...
            </h1>
          </v-col>
        </v-row>
      </v-container>

      <v-container v-show="loaded" fluid>
        <v-row :class="{ 'fill-height': !isMultiDevice }">
          <v-col>
            <!-- THE TOP GRAPH -->
            <v-card
              tile
              :height="topGraphHeight"
              class="pr-5 pt-2 pb-2 pl-2"
              :class="{ 'mb-5': numGraphs == 2 }"
              style="box-sizing: border-box;"
            >
              <m-graph
                :model="$store.state.log"
                :modelVersion="$store.state.logVersion"
                @highlightrow="highLightRow"
                @loaded="loaded = true"
                :controlIndex="0"
                :highlight-pos.sync="highlightedIndex"
                :date-window.sync="dateWindow"
                :showButtonVisible="numGraphs == 1 && !isMultiDevice"
                :legendVisible="tableView == 'hide'"
                @showClicked="
                  numGraphs = 2;
                  $store.commit('incrementLogVersion');
                "
              ></m-graph>
            </v-card>

            <!-- THE BOTTOM GRAPH -->
            <v-card
              v-if="!isMultiDevice"
              v-show="numGraphs > 1"
              tile
              height="calc(50vh - 66px)"
              class="pr-5 pb-2 pt-2 pl-2"
            >
              <m-graph
                :isVisible="numGraphs > 1"
                :model="$store.state.log"
                :modelVersion="$store.state.logVersion"
                @highlightrow="highLightRow"
                @loaded="loaded = true"
                :controlIndex="1"
                :highlight-pos.sync="highlightedIndex"
                :date-window.sync="dateWindow"
                :hideButtonVisible="numGraphs == 2"
                :legendVisible="tableView == 'hide'"
                @hideClicked="
                  numGraphs = 1;
                  $store.commit('incrementLogVersion');
                "
              ></m-graph>
            </v-card>
          </v-col>

          <!-- THE TABLE VIEW -->
          <v-col v-if="tableView != 'hide'" cols="auto" style="padding:12;">
            <m-table
              v-if="tableView == 'all'"
              @resize="triggerResize"
              :numGraphs="numGraphs"
              :height="tableViewHeight"
            ></m-table>
            <m-maxmin
              v-else-if="tableView == 'maxmin'"
              @resize="triggerResize"
              :num-graphs="numGraphs"
              :height="tableViewHeight"
            ></m-maxmin>
          </v-col>
        </v-row>
        <!-- Multi-device legend spanning full width -->
        <v-row v-if="isMultiDevice">
          <v-col>
            <multi-device-legend></multi-device-legend>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import usbRequest from "../mixins/usb-request";
import apiEp from "../mixins/api-endpoints";
import apiReq from "../mixins/api-request";
import formatDate from "../mixins/format-date";

export default {
  mixins: [usbRequest, apiEp, apiReq, formatDate],
  data() {
    return {
      loaded: false,
      privateNumGraphs: 2,
      highlightedIndex: null,
      dateWindow: [],
      tableView: "hide",
      linkExpired: false,
      linkInvalid: false,
      dateString: ""
    };
  },
  methods: {
    showError(message) {
      this.$refs.errorBox.showError(message);
    },
    onMenuFileOpen(evt) {
      let fileInput = this.$refs.fileOpenElem;
      fileInput.click();
    },
    openFile(evt) {
      let fileInput = this.$refs.fileOpenElem;
      if (!fileInput.files) return;

      var file = fileInput.files[0];
      if (file.name.toLowerCase().endsWith(".cht")) {
        this.processChtFile(file);
      } else if (file.name.toLowerCase().endsWith(".jlg")) {
        this.processJlgFile(file);
      } else if (file.name.toLowerCase().endsWith(".log")) {
        this.processLogFile(file);
      } else {
        alert("Unable to determine file type!");
      }

      fileInput.value = "";
    },
    setPeriod(hours) {
      console.log("Set Period: ", hours);
    },
    triggerResize() {
      // trigger a resize event so that the components redraw
      // I'm just using setTimeout to add the event after the call stack.
      window.setTimeout(() => {
        // chrome/ff
        //window.dispatchEvent(new Event('resize'));

        // IE/chrome/ff
        var resizeEvent = window.document.createEvent("UIEvents");
        resizeEvent.initUIEvent("resize", true, false, window, 0);
        window.dispatchEvent(resizeEvent);
      }, 100);
    },
    onMenuTableHide(evt) {
      console.log("MenuTableHide");
      this.tableView = "hide";
      this.triggerResize();
    },
    onMenuTableAll(evt) {
      console.log("MenuTableAll");
      this.tableView = "all";
      this.triggerResize();
    },
    onMenuTableMaxMin(evt) {
      console.log("MenuTableMaxMin");
      this.tableView = "maxmin";
      this.triggerResize();
    },
    highLightRow(evt) {
      this.$store.commit("setSelectedTimestamp", evt);
    },
    onDateSelect(dateString) {
      var timeStamp = new Date(dateString).getTime();
      this.loadChartDataFromServer(timeStamp);
    },
    loadChartDataFromServer(atDate) {
      const selectedGraphLine = this.$route.query.selected_graph_line || "cli";
      const devices = this.$route.query["devices[]"] || [];
      const params = new URLSearchParams();
      let apiEndpoint = this.apiEndpoints.logs;

      if (devices.length > 0) {
        apiEndpoint = this.apiEndpoints.multipleDeviceLogs;
        params.append("selected_graph_line", selectedGraphLine);
        devices.forEach(device => params.append("devices[]", device));
      }

      if (atDate) {
        params.append("starting_at", atDate / 1000 - 14 * 24 * 60 * 60);
        params.append("ending_at", atDate / 1000 + 14 * 24 * 60 * 60);
      }

      // ****** mp035: Links are not used on the huntsman system
      // so this branch will never execute.
      if (this.$route.name == "link") {
        // if this is a link, then load from the link endpoint
        console.log("Loading link ID: " + this.$route.params.token);
        this.apiRequest(
          this.apiEndpoints.showLink,
          this.$route.params.token,
          params.toString,
          {
            Accept: "application/octet-stream"
          }
        ).then(r => {
          if (this.checkStatus(r, "Error getting file from server.")) {
            try {
              this.loadChartResponse(r.body);
            } catch {
              // the chart response could not be loaded.  Maybe it is an error packet due to invalid/expired link
              if (r.body && r.body.data) {
                if (r.body.data.expired) {
                  this.linkExpired = true;
                } else if (r.body.data.invalid) {
                  this.linkInvalid = true;
                } else {
                  this.showError(
                    "Unknown response from server. (Status is 200[success], and content can be decoded, but is invalid.)"
                  );
                }
              } else {
                this.showError(
                  "Unknown response from server. (Status is 200[success] but content is invalid.)"
                );
              }
            }
          }
        });
      } else {
        // load a new log.

        this.loaded = false;
        let currentPageHref = window.location.href;
        this.apiRequest(apiEndpoint, this.$route.params.id || null, params, {
          Accept: "application/octet-stream"
        })
          .then(r => {
            // downloading log files can be slow, so if the user changes the
            // page during the download, abort loading the file.
            if (window.location.href != currentPageHref) {
              console.log(
                "The page url has changed.  Aborting load of log content."
              );
              return;
            }

            if (r == null) {
              console.error("apiRequest returned an empty response.");
              this.showError(
                "The server returned an empty response.  Try going back to the home page!"
              );
            } else if (this.checkStatus(r, "Error getting file from server.")) {
              this.loadChartResponse(r.body);
            }
            this.loaded = true;
          })
          .catch(ex => {
            console.log(ex, "---- Error loading chart data from server ----");
            // if there is an error loading the log (perhaps a bad bookmark, or not logged in) just redirect
            // to the home page
            this.$router.replace("/");
          });
      }
    },
    consoleLog(x) {
      console.log(x);
    }
  },
  mounted() {
    this.loadChartDataFromServer();
  },
  computed: {
    isMultiDevice() {
      return this.$route.name == "multi_graph";
    },
    numGraphs: {
      get() {
        return this.isMultiDevice ? 1 : this.privateNumGraphs;
      },
      set(value) {
        this.privateNumGraphs = value;
      }
    },
    topGraphHeight() {
      if (this.numGraphs == 2) {
        return "calc(50vh - 66px)";
      } else if (this.isMultiDevice) {
        return "calc(100vh - 428px)";
      }
      return "calc(100vh - 112px)";
    },
    tableViewHeight() {
      if (this.isMultiDevice) {
        return this.topGraphHeight;
      }
      return "calc(100vh - 112px)";
    }
  }
};
</script>
